//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
import { scrollbarToBrowserBottom } from '~/utils';
export default {
  name: 'HomeIndexData',
  filters: {
    netChangeFilter(str) {
      return (str * 100).toFixed(2) + '%';
    },
    shszFilter(str) {
      return (str / 100000000).toFixed(2);
    },
  },
  data() {
    return {
      dataList: [],
      timeInterval: null,
    };
  },

  created() {
    clearInterval(this.timeInterval);
  },
  mounted() {
    this.timeInterval = setInterval(() => {
      this.getData();
    }, 30000);
    this.getData();
  },
  methods: {
    async getData() {
      const rsp = await this.$axios(api.getHomeData());
      const dataList = [
        '上证指数',
        '深证成指',
        '创业板指',
        '恒生指数',
        '道琼斯指数',
        '北上资金',
        '南下资金',
      ];
      const list = rsp.result;
      if (list && list.length > 0) {
        list.forEach(item => {
          if (dataList.includes(item.name)) {
            dataList[dataList.indexOf(item.name)] = item;
          }
        });
        this.dataList = dataList;
        this.show = true;
      }
    },
    handler() {
      const range = scrollbarToBrowserBottom();
      if (range < 610) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
};
